module.exports = __webpack_public_path__ + "img/template_story_2.26e41abf.jpg";